import { Component } from '@angular/core';

import { Loggable } from 'app/utils/logging/loggable';

import { ToastBannerConfig, toastTypes } from '../types/toast-banners';

@Component({
  selector: 'app-toast-banner-message',
  templateUrl: './toast-banner-message.component.html',
  styleUrls: ['./toast-banner-message.component.scss'],
  standalone: false,
})
export class ToastBannerMessageComponent extends Loggable {
  /**
   * Toaster parameters - configure message and colors
   * @param message - Message to be showed in the banner
   * @param icon - Icon to be used - Code from mat-icon lib (Ex: warning)
   * @param svgIcon - Icon to be used - Code from intern SVG lib (Ex: CLOSE)
   * @param messageType - Toast type (warning, success, etc)
   * @param toasterConfig - Toast configuration type and colors
   */
  public message = '';
  public icon = '';
  public svgIcon = '';
  public messageType = toastTypes.DEFAULT;
  public toasterConfig!: ToastBannerConfig;

  public onClose(): void {
    //TODO: Implement according to the built activation structure
  }
}
